import { FC, ReactNode } from "react";
import { ThemeProvider } from "@emotion/react";
import theme from "../theme";
import Drawer from "./Drawer";

export interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* <Header />
        <NavBar />
        
        <div>{children}</div>
        <Footer /> */}
        <Drawer children={children} />
      </div>
    </ThemeProvider>
  );
};

export default Layout;
